import { Col, Row } from "antd";
import { JobDepartmentSelector } from "features/v2/job/department/jobDepartmentSelector";
import { DataTableSearch } from "common/components/dataTableLayout/dataTableSeach";
import { JobStatusSelector } from "features/v2/job/status/jobStatusSelector";
import K from "utilities/constants";
import styles from "features/dashboard/sections/jobs/filters/filters.module.scss";

export const OpenPendingJobsFilters = ({
  search,
  onSearchChange,
  jobStatus,
  onJobStatusChange,
  jobDepartment,
  onJobDepartmentChange,
  clientId,
  disabled = false,
}) => {
  return (
    <Row gutter={[8, 8]} className={styles.openPendingJobsFilters}>
      <Col className={styles.openPendingJobsFilters__searchCol}>
        <DataTableSearch
          defaultValue={search}
          onChange={(e) => onSearchChange(e.target.value || null)}
        />
      </Col>
      <Col className={styles.openPendingJobsFilters__departmentCol}>
        <JobDepartmentSelector
          clientId={clientId}
          value={jobDepartment}
          onChange={onJobDepartmentChange}
          disabled={disabled}
        />
      </Col>
      <Col className={styles.openPendingJobsFilters__statusCol}>
        <JobStatusSelector
          filterStatuses={[K.JobStatusName.Open, K.JobStatusName.Pending]}
          defaultValue={jobStatus}
          placeholder="Select Status"
          onChange={(statusId, status) => onJobStatusChange(status)}
          disabled={disabled}
        />
      </Col>
    </Row>
  );
};
